import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@context/AuthContext';

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(form.email, form.password);
      navigate('/admin');
    } catch (err) {
      setError(typeof err === 'string' ? err : 'Invalid credentials. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{minHeight:'100vh',background:'radial-gradient(ellipse 80% 60% at 50% 30%,rgba(255,107,0,.14) 0%,rgba(36,0,70,.25) 50%,transparent 100%)',display:'flex',alignItems:'center',justifyContent:'center',padding:'2rem 1rem'}}>
      {/* Mandala BG */}
      <div style={{position:'fixed',top:'50%',left:'50%',transform:'translate(-50%,-50%)',width:'min(90vw,700px)',height:'min(90vw,700px)',opacity:.04,animation:'spin 90s linear infinite',pointerEvents:'none',zIndex:0}}>
        <svg viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="100" cy="100" r="95" stroke="#FFB800" strokeWidth=".5"/>
          <circle cx="100" cy="100" r="75" stroke="#FF6B00" strokeWidth=".4"/>
          <circle cx="100" cy="100" r="55" stroke="#FFB800" strokeWidth=".5"/>
          <circle cx="100" cy="100" r="35" stroke="#FF6B00" strokeWidth=".4"/>
          {Array.from({length:16},(_,i)=>{const a=i*(360/16)*Math.PI/180;return <line key={i} x1="100" y1="100" x2={100+95*Math.cos(a)} y2={100+95*Math.sin(a)} stroke="#FFB800" strokeWidth=".3"/>;}) }
          <text x="100" y="108" textAnchor="middle" fill="#FFB800" fontSize="22" fontFamily="serif">ॐ</text>
        </svg>
      </div>

      <div style={{position:'relative',zIndex:1,width:'100%',maxWidth:420}}>
        <div style={{textAlign:'center',marginBottom:'2.5rem'}}>
          <div style={{fontSize:'3rem',marginBottom:'.5rem',animation:'glow 3s ease-in-out infinite'}}>ॐ</div>
          <div style={{fontFamily:"'Cinzel Decorative',serif",fontSize:'1.5rem',fontWeight:700,background:'linear-gradient(135deg,#FFE082,#FF6B00)',WebkitBackgroundClip:'text',WebkitTextFillColor:'transparent',marginBottom:'.3rem'}}>CosmicHindu</div>
          <div style={{fontFamily:"'Cinzel',serif",fontSize:'.65rem',letterSpacing:'.3em',textTransform:'uppercase',color:'rgba(255,184,0,.5)'}}>Admin Portal</div>
        </div>

        <div style={{background:'linear-gradient(135deg,rgba(20,4,0,.95),rgba(26,10,46,.95))',border:'1px solid rgba(255,184,0,.25)',borderRadius:12,padding:'2.5rem',backdropFilter:'blur(20px)'}}>
          <h2 style={{fontFamily:"'Cinzel',serif",fontSize:'.75rem',letterSpacing:'.25em',textTransform:'uppercase',color:'rgba(255,224,130,.55)',textAlign:'center',marginBottom:'2rem'}}>
            🔐 Secure Admin Access
          </h2>

          {error && (
            <div style={{background:'rgba(192,57,43,.2)',border:'1px solid rgba(192,57,43,.4)',borderRadius:6,padding:'.75rem 1rem',marginBottom:'1.2rem',fontFamily:"'Cinzel',serif",fontSize:'.75rem',color:'#ff6b6b',textAlign:'center'}}>
              ⚠️ {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div style={{marginBottom:'1.2rem'}}>
              <label style={{display:'block',fontFamily:"'Cinzel',serif",fontSize:'.62rem',letterSpacing:'.2em',textTransform:'uppercase',color:'rgba(255,184,0,.6)',marginBottom:'.5rem'}}>Email</label>
              <input
                type="email" required autoComplete="email"
                value={form.email} onChange={e=>setForm({...form,email:e.target.value})}
                placeholder="admin@cosmichindu.com"
                style={{width:'100%',padding:'.85rem 1rem',background:'rgba(255,255,255,.06)',border:'1px solid rgba(255,184,0,.25)',borderRadius:6,color:'#FFE082',fontFamily:"'Crimson Pro',serif",fontSize:'1rem',outline:'none',boxSizing:'border-box'}}
              />
            </div>
            <div style={{marginBottom:'1.8rem'}}>
              <label style={{display:'block',fontFamily:"'Cinzel',serif",fontSize:'.62rem',letterSpacing:'.2em',textTransform:'uppercase',color:'rgba(255,184,0,.6)',marginBottom:'.5rem'}}>Password</label>
              <input
                type="password" required autoComplete="current-password"
                value={form.password} onChange={e=>setForm({...form,password:e.target.value})}
                placeholder="Enter password"
                style={{width:'100%',padding:'.85rem 1rem',background:'rgba(255,255,255,.06)',border:'1px solid rgba(255,184,0,.25)',borderRadius:6,color:'#FFE082',fontFamily:"'Crimson Pro',serif",fontSize:'1rem',outline:'none',boxSizing:'border-box'}}
              />
            </div>
            <button
              type="submit" disabled={loading}
              style={{width:'100%',padding:'1rem',fontFamily:"'Cinzel',serif",fontSize:'.82rem',fontWeight:700,letterSpacing:'.2em',textTransform:'uppercase',background:loading?'rgba(255,107,0,.4)':'linear-gradient(135deg,#FF6B00,#FFB800)',color:'#0D0500',border:'none',borderRadius:6,cursor:loading?'not-allowed':'pointer'}}
            >
              {loading ? '🌀 Signing In…' : '🔱 Enter Admin Panel'}
            </button>
          </form>

          <div style={{textAlign:'center',marginTop:'1.5rem',fontFamily:"'Cinzel',serif",fontSize:'.6rem',letterSpacing:'.15em',color:'rgba(255,224,130,.25)'}}>
            ॐ शांति शांति शांति ॐ
          </div>
        </div>
      </div>
    </div>
  );
}
